// U-TOPIA Investor Deal Room, central content source

export const NAV_LINKS = [
  { id: "thesis", label: "Thesis" },
  { id: "story", label: "Story" },
  { id: "deal", label: "The Deal" },
  { id: "funds", label: "Use of Funds" },
  { id: "traction", label: "Traction" },
  { id: "product", label: "Product" },
  { id: "agentic", label: "Agentic" },
  { id: "roadmap", label: "Roadmap" },
  { id: "market", label: "Market" },
  { id: "team", label: "Team" },
  { id: "dataroom", label: "Data Room" },
  { id: "invest", label: "Invest" },
];

export const HERO_LINES = [
  "U-TOPIA is a",
  "self-custody,",
  "Visa card enabled,",
  "agentic payments super app.",
];

export const HERO_HIGHLIGHT = "agentic payments";

export const HERO_SUB =
  "A non-custodial wallet, a Visa card, and an AI-native payment agent, powered by U.CENTER, our activation community of 5,200+ members already onboard.";

export const METRICS = [
  { k: "Round", v: "Seed • SAFE" },
  { k: "Valuation Cap", v: "$100M • 20% Disc." },
  { k: "Raise", v: "Up to $5M" },
  { k: "Public Launch", v: "Oct 16, 2026" },
  { k: "Community", v: "5,200 → 10,000" },
];

export const DEAL_TERMS = [
  { term: "Round", detail: "Seed" },
  { term: "Instrument", detail: "SAFE (Simple Agreement for Future Equity)" },
  { term: "Valuation Cap", detail: "$100,000,000" },
  { term: "Discount", detail: "20%" },
  { term: "Round Ceiling", detail: "$5,000,000" },
  { term: "Minimum Investment", detail: "$250,000 (institutions) / $50,000 (angels)" },
  { term: "Eligibility", detail: "Accredited investors only" },
  { term: "Offering Type", detail: "Regulation D" },
];

export const DEAL_NOTE =
  "This is a Regulation D offering open exclusively to accredited investors. The SAFE provides investors with a 20% discount to the price of the next equity round or conversion at the $100M valuation cap, whichever is more favorable to the investor.";

export const FUNDS_INTRO =
  "Allocation designed to deliver 18 months of runway while prioritizing product readiness, compliance, and conversion of the existing community.";

export const USE_OF_FUNDS = [
  {
    category: "Product Development",
    pct: 15,
    amount: "$750K",
    purpose:
      "Finalization of core wallet, stablecoin rails, debit card integrations, security, and post-launch iteration.",
  },
  {
    category: "Compliance, Legal & Licensing",
    pct: 18,
    amount: "$900K",
    purpose:
      "Regulatory pathway, licensing, KYC/AML infrastructure, card program setup, and ongoing compliance.",
  },
  {
    category: "User Acquisition & Growth",
    pct: 28,
    amount: "$1.4M",
    purpose:
      "Converting the 5,200-member community, scalable acquisition channels, referral systems, and onboarding optimization.",
  },
  {
    category: "Events & Community Activation",
    pct: 10,
    amount: "$500K",
    purpose:
      "Launch events, regional activations, ambassador programs through U.CENTER, and high-touch community conversion.",
  },
  {
    category: "Operations & Team",
    pct: 17,
    amount: "$850K",
    purpose: "Core team, key hires, infrastructure, tools, and day-to-day operations.",
  },
  {
    category: "Reserve / Contingency",
    pct: 12,
    amount: "$600K",
    purpose: "Buffer for extended runway, unexpected costs, or opportunistic moves.",
  },
];

export const FUNDS_NOTE =
  "This allocation is weighted toward growth and community activation while protecting the compliance foundation and maintaining a healthy reserve.";

export const TRACTION_POINTS = [
  {
    value: "Beta",
    label: "Currently in community beta testing ahead of public launch.",
  },
  {
    value: "5,200+",
    label: "Members already activated across the community today.",
  },
  {
    value: "10,000",
    label: "Target members by public launch on October 16, 2026.",
  },
  {
    value: "AU",
    label: "Strong organic growth from Australia, the emerging beachhead.",
  },
];

export const PARTNERS = [
  { partner: "Rain", role: "Visa card issuance" },
  { partner: "Persona", role: "KYC / AML" },
  { partner: "Fireblocks", role: "Wallet infrastructure & security" },
  { partner: "Noah", role: "Fiat on-ramp / off-ramp, local currency payouts, and USD accounts" },
];

export const PRODUCT_INTRO =
  "U-TOPIA is a non-custodial financial operating system that gives users full control of their assets while delivering the practical tools of modern banking: wallets, stablecoin payments, debit cards, fiat on/off-ramps, and treasury features.";

export const CAPABILITIES = [
  {
    icon: "Wallet",
    title: "Non-custodial wallets",
    body: "Users hold their own keys. Built on Fireblocks for institutional-grade security.",
  },
  {
    icon: "Zap",
    title: "Stablecoin rails & instant payments",
    body: "Fast, low-cost movement of value across borders.",
  },
  {
    icon: "CreditCard",
    title: "Visa debit cards",
    body: "Issued through Rain, enabling real-world spending.",
  },
  {
    icon: "ArrowLeftRight",
    title: "Fiat on / off-ramps & payouts",
    body: "Powered by Noah, including local currency payouts and USD accounts.",
  },
  {
    icon: "ShieldCheck",
    title: "KYC / AML",
    body: "Handled by Persona for compliant onboarding at scale.",
  },
  {
    icon: "Landmark",
    title: "Treasury tools",
    body: "Cash management and balance controls for individuals and small teams operating globally.",
  },
];

export const PRODUCT_OUTRO =
  "The product combines self-custody with production-ready financial rails inside one experience. U.CENTER serves as the community and activation layer.";

export const AGENTIC_INTRO =
  "The next layer of U-TOPIA turns the wallet into a personal financial agent. Instead of juggling dozens of apps, subscriptions, invoices, and cross-border transfers, users delegate the tedious work to an AI-native payment engine that runs inside their non-custodial wallet, with policy limits, approvals, and full self-custody preserved.";

export const AGENTIC_PILLARS = [
  {
    icon: "Repeat",
    title: "Autonomous bill pay & subscriptions",
    body:
      "Recurring payments, renewals, and vendor decisions handled inside the spending policies you set, never a missed bill, never a surprise charge.",
  },
  {
    icon: "Globe",
    title: "Cross-border settlement, zero friction",
    body:
      "A single instruction turns into an optimal fiat + stablecoin route across Noah rails and card networks, no more manual FX or wire timing.",
  },
  {
    icon: "Sparkles",
    title: "Delegated commerce",
    body:
      "Give your agent a budget and a task, “book flights under $600 to Lisbon in March.” It pays with your Visa card, keeps receipts, and reports back.",
  },
  {
    icon: "SlidersHorizontal",
    title: "Programmable spend policies",
    body:
      "Merchant, category, and time-boxed rules enforced at the wallet layer, every action is auditable and self-custody stays intact.",
  },
];

export const AGENTIC_OUTRO =
  "Agentic payments turn every U-TOPIA account into leverage, hours of admin returned every week, so users can focus on what actually matters.";

export const ROADMAP = [
  {
    phase: "Now – October 16, 2026",
    tag: "Community Beta → Public Launch",
    items: [
      "Continue community beta and iterate",
      "Finalize core product features",
      "Complete remaining compliance readiness",
      "Scale community from 5,200 → 10,000 members",
      "Prepare Australia beachhead go-to-market",
      "Public launch: October 16, 2026",
    ],
  },
  {
    phase: "Q4 2026 – Q1 2027",
    tag: "Launch & Early Growth",
    items: [
      "Full public availability",
      "Convert waitlist into active users",
      "Optimize onboarding, card issuance, and fiat flows",
      "Deepen Australia market penetration",
      "Begin targeted acquisition and community events",
    ],
  },
  {
    phase: "Q2 – Q4 2027",
    tag: "Scale & Expansion",
    items: [
      "Expand features based on live usage",
      "Broaden geographic focus beyond Australia",
      "Strengthen compliance and operational capacity",
      "Scale team and infrastructure",
    ],
  },
];

export const ROADMAP_OUTCOME =
  "18 Month Outcome Target: A live, compliant non-custodial financial product with meaningful active usage, a scaled community, proven unit economics in the beachhead market, and a clear path to broader expansion.";

export const MARKET_INTRO =
  "The demand for better digital financial infrastructure continues to expand as more people and businesses operate across borders and expect self-custody, speed, and real-world utility.";

export const MARKET_DYNAMICS = [
  "Stablecoins are evolving from trading collateral into real payment and settlement rails, supply above $300B in 2026, with multi-trillion annual volumes and institutional forecasts projecting significant further growth.",
  "Digital and neo-banking continue to scale globally.",
  "Traditional cross-border payments still carry high fees and friction.",
  "Growing preference for self-custody among digitally native and internationally mobile users.",
];

export const MARKET_AU =
  "Australia as beachhead: strong digital and crypto adoption, an active neo-banking market, and improving regulatory clarity. Current community growth shows Australia as a natural initial focus while the product is global from day one.";

export const MARKET_POSITION =
  "Most solutions force a trade-off between custodial convenience and pure self-custody with limited real-world utility. U-TOPIA sits at the intersection of non-custodial control, stablecoin rails, Visa debit spending, and regulated fiat access, activated by an existing community layer.";

export const MARQUEE_WORDS = [
  "Non-custodial control",
  "Stablecoin rails",
  "Visa debit spending",
  "Regulated fiat access",
  "Community-activated",
];

export const TEAM = [
  {
    name: "Emmanuel Quezada",
    role: "Founder & Chief Executive Officer",
    photo: "/team/emmanuel.jpg",
    bio: "A serial builder who started his first company at 15 and shipped his first app by 16. A Forbes 30 Under 30 honoree, Emmanuel brings entrepreneurial velocity and operating discipline to U-TOPIA. His family runs Grupo ATS (ATS Group).",
    credentials: [
      "Started his first company at 15",
      "Developed his first app by 16",
      "Forbes 30 Under 30",
      "Family runs ATS Group",
    ],
  },
  {
    name: "Kyle Kemper",
    role: "President, U-TOPIA, Inc.",
    photo: "/team/kyle.jpg",
    bio: "A bold advocate of Bitcoin and blockchain innovation since 2013, Kyle bridges politics, media, and digital finance with unapologetic conviction.",
    credentials: [
      "Executive Director, Blockchain Association of Canada",
      "Advisor to Kraken",
      "Featured on Tucker Carlson",
    ],
  },
  {
    name: "Maya Nicks",
    role: "Head of AI",
    photo: "/team/maya.jpg",
    bio: "Maya leads U-TOPIA's human-centered AI strategy, combining machine learning, Web3, privacy, and ethical technology to keep the platform intelligent and trustworthy.",
    credentials: ["Cyber Security", "Certified Pilot", "Social Media Influencer"],
  },
  { name: "Sohaib Arif", role: "Head of Product Development", photo: "/team/sohaib.jpg" },
  { name: "Sean Walsh", role: "Chief Marketing Officer", photo: "/team/sean.jpg" },
  { name: "Rachan (Tony) Jaipun", role: "Partnerships", photo: "/team/tony.jpg" },
  { name: "Karla", role: "Office Manager", photo: "/team/karla.jpg" },
];

export const DATA_ROOM = [
  {
    category: "Corporate & Legal",
    items: [
      "Certificate of Incorporation (U-TOPIA, Inc. – Puerto Rico C-Corp)",
      "Bylaws / operating summary",
      "Cap table summary",
      "SAFE template and subscription documents",
      "Regulation D disclosures",
    ],
  },
  {
    category: "Product & Technology",
    items: [
      "Product overview and feature list",
      "Beta status and screenshots / demo access",
      "Partnership summaries (Rain, Persona, Fireblocks, Noah)",
      "High-level architecture and security overview",
    ],
  },
  {
    category: "Market & Traction",
    items: [
      "Community metrics and launch targets",
      "Australia beachhead rationale",
      "Launch roadmap",
    ],
  },
  {
    category: "Financial",
    items: [
      "Use of Funds breakdown",
      "High-level financial model / projections (when available)",
      "Runway assumptions",
    ],
  },
  {
    category: "Team",
    items: ["Leadership bios (to be expanded)"],
  },
];

export const DATA_ROOM_NOTE =
  "Access to the full data room is provided to serious accredited investors after initial qualification.";

export const INVEST_STEPS = [
  "Confirm accredited investor status",
  "Request access to the full data room and SAFE documentation",
  "Review materials and schedule a call if desired",
  "Complete subscription documents",
  "Wire funds per instructions provided",
];

export const CONTACT_EMAIL = "karla@u-topia.com";

export const STORY_CHAPTERS = [
  {
    n: "01",
    headline: "Money at the speed of a message.",
    body:
      "We can send words across the planet instantly for free. Money still takes days, still costs too much, and still asks the user to do the busywork themselves.",
    quote:
      "Everyone in this room sent a message this morning without thinking about it. Nobody in this room sent money the same way. That gap is the company.",
  },
  {
    n: "02",
    headline: "History says otherwise.",
    body:
      "Communication went from smoke signals to the telephone to the mobile phone. Money went from barter to gold to paper to banks and cards, and stopped. Sending $200 home still costs 6.36% on average against a 3% UN target. Last year $685 billion crossed borders as remittances, more than foreign investment and aid combined.",
    quote:
      "Every generation thinks its version of money is the final one. History says otherwise.",
  },
  {
    n: "03",
    headline: "Digital money solved the speed. It never solved the people.",
    body:
      "Before we wrote a line of code, we funded twelve researchers for months. They produced 1,400 articles on what was wrong with crypto. Three findings, one cause: nobody trusted it, nobody could use it, and nobody built it for the young or the old, because nobody could read it. Every product decision since has been an act of translation.",
    quote:
      "We did the research before we wrote a line of code. That is unusual in this category, and it is why the product looks the way it does.",
  },
  {
    n: "04",
    headline: "The trade-off nobody should have to make.",
    body:
      "Today a person chooses between convenience and ownership, and still carries the mental load themselves. Custodial apps are easy, and they hold your money. Self-custody wallets keep you in control, and give you no way to spend. The few self-custody cards that exist serve about thirty European countries. Where the need is greatest, the Gulf, South and Southeast Asia, Africa, Latin America, nobody serves the whole package.",
    quote:
      "Everyone else makes you choose. We built the one product where you do not.",
  },
  {
    n: "05",
    headline: "Self-custody. A Visa card. An agent.",
    body:
      "One app. Open it in about eight minutes. Fund it in two seconds. Your keys stay in your pocket, never in ours. Send anywhere in under two seconds. Hold a stable dollar balance. Spend on a Visa card in any shop. Move to a bank in under a minute. And, through our agentic layer, delegate the tedious parts: bills, subscriptions, renewals, cross-border timing, receipts. Non-custodial control. Real-world spending. Time back.",
    quote:
      "I designed it for one user, my mother. She opens it in eight minutes. I fund it in two seconds. Seven seconds later she is paying for her shopping.",
  },
  {
    n: "06",
    headline: "Three curves crossed. A fourth is here.",
    body:
      "Behavior, monthly spending on crypto-linked cards reached $833 million in May 2026, up 180% year on year, with cumulative volume past $9 billion. Infrastructure, card issuing on stablecoin rails is now an API; the same product needed a bank charter three years ago. Regulation, MiCA in Europe, DFSA and VARA in the UAE, mature VASP regimes across Southeast Asia; compliance stopped being the obstacle and became the moat. And AI, agents that can move money safely, inside your rules, are finally practical.",
    quote:
      "Rules arrived, and the technology grew up. The excuse for not owning your own money has gone.",
  },
  {
    n: "07",
    headline: "The person who sends money home.",
    body:
      "One hero proves every promise at once. Speed, because the money is needed today. Cost, because every fee comes out of her family's share. Ownership, because she earned it far from home. She is also the growth model, her first transfer brings her family onto the app. Every transfer has two ends, so every transfer is an invitation. UAE and Saudi outflows are around $79 billion a year. Inflows to the Philippines and Indonesia exceed $70 billion. We are headquartered in the corridor.",
    quote:
      "Children bring in their parents, and parents bring in their children. That line was written about families. It is also our customer acquisition strategy.",
  },
  {
    n: "08",
    headline: "You will be able to talk to your money.",
    body:
      "The 2027 roadmap: bank-to-crypto and crypto-to-bank in both directions, more than 100 everyday currencies side by side, tokenized stocks and commodities through registered issuance partners, family accounts as regulation allows, inheritance with named beneficiaries, and u.bot, an assistant a person can talk to about their money. This is where every chapter lands. Owning your money. Moving it like a message. And finally letting an agent handle the parts you shouldn't have to.",
    quote:
      "You will be able to talk to your money. That is not a slogan. It is the 2027 roadmap.",
  },
  {
    n: "09",
    headline: "One word that needs no translation.",
    body:
      "Utopia is the same word in almost every language. It means the world that does not exist yet. That is why it is our name, a direction, not a claim. Anyone, in any country, at any age, owning their money and moving it as easily as they send a message. U-topia is loading.",
    quote:
      "We expect this to take more than one generation. We would like you with us for the first one.",
  },
];

export const DECK = {
  title: "Hold Digital Money. Spend it Anywhere.",
  subtitle: "Investor Presentation · August 2026",
  pages: 23,
  cover: "/deck-preview.jpg",
  file: "/hold-digital-money.pdf",
  size: "10.8 MB",
};

export const LIVE_HIGHLIGHTS = [
  { k: "Live today", v: "Non-custodial wallet · Visa card · fiat rails" },
  { k: "50", v: "Launch countries" },
  { k: "135+", v: "Fiat currencies on the roadmap" },
  { k: "100%", v: "Self-custody, users keep the keys" },
];
